import { AvailableDevices } from '../types/Video';

export const getMediaDevices = async () => {
  const devices: AvailableDevices = {
    audioInputs: [],
    audioOutputs: [],
    videoInputs: [],
  };

  try {
    const allDevices = await navigator.mediaDevices.enumerateDevices();

    allDevices.forEach((device) => {
      if (device.label) {
        if (device.kind === 'audioinput') {
          devices.audioInputs.push(device);
        } else if (device.kind === 'audiooutput') {
          devices.audioOutputs.push(device);
        } else if (device.kind === 'videoinput') {
          devices.videoInputs.push(device);
        }
      }
    });

    return devices;
  } catch (error) {
    console.error('Error enumerating media devices:', error);
  }

  return devices;
};
